import ModalDropdownContainer from 'components/Shared/SearchFilter/ModalDropdownContainer';
import DropdownContainer from 'components/Shared/SearchFilter/DropdownContainer';
import CheckMenuList from 'components/Shared/SearchFilter/CheckMenuList';
import { screen } from 'components/styles/variables';

import CategoryTapEvent from 'lib/Tracking/Srp/SearchFilters/CategoryTap';
import CategoryViewEvent from 'lib/Tracking/Srp/SearchFilters/CategoryView';
import { useCategoryFilter } from 'lib/hooks/useSrpFilters';
import useEvents from 'lib/hooks/useEvents';

import { SrpCategoryValue } from 'types/srpFilters';
import { useContext, useMemo } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import Accordion from 'components/Shared/SearchFilter/Accordion';
import { CategoryFacet } from 'lib/apis/SearchApi/types';
import { categoryList, getCategoryApiName, stateNames, facetToStateNames } from './categoryNames';

export default function CategoryFilter({
  expanded,
  categoryFacets,
}: {
  expanded?: boolean;
  categoryFacets?: CategoryFacet;
}): JSX.Element {
  const { value: selectedCategory, setValue: setCategory } = useCategoryFilter();
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const placeHolderTitle = selectedCategory
    ? stateNames[selectedCategory] || selectedCategory
    : selectedCategory;

  function handleSelect(selectedValue: SrpCategoryValue): void {
    let apiName = selectedValue;
    if (typeof selectedValue === 'string' && selectedValue !== selectedValue.toLowerCase()) {
      apiName = getCategoryApiName(selectedValue) || selectedValue.toLowerCase();
    }
    logger.log(CategoryTapEvent(apiName, sourcePage));
    setCategory(selectedValue);
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line consistent-return
  function onFilterClick(isExpanding: boolean): Promise<void> {
    if (isExpanding) {
      return logger.log(CategoryViewEvent({ sourcePage }));
    }
  }

  const categoryOptions = useMemo(() => {
    return categoryList.map((category) => category);
  }, []);

  const transformedFacetCounts = useMemo(() => {
    if (!categoryFacets) return {};
    return Object.entries(categoryFacets).reduce((acc, [key, value]) => {
      const uiName = facetToStateNames[key];
      if (uiName) {
        acc[uiName] = value;
      }
      return acc;
    }, {} as Record<string, number>);
  }, [categoryFacets]);

  return (
    <>
      <Accordion title="Vehicle Category" expanded={expanded} onClick={onFilterClick}>
        <div className="category-modal-container">
          <ModalDropdownContainer placeHolderTitle={placeHolderTitle} handleClick={(): void => {}}>
            <CheckMenuList
              options={categoryOptions}
              selected={selectedCategory}
              onSelect={handleSelect}
              facetCounts={transformedFacetCounts}
            />
          </ModalDropdownContainer>
        </div>
        <div className="category-dropdown-container">
          <DropdownContainer title={placeHolderTitle} resetsOnClose={true} onClick={(): void => {}}>
            <CheckMenuList
              options={categoryOptions}
              selected={selectedCategory}
              onSelect={handleSelect}
              facetCounts={transformedFacetCounts}
            />
          </DropdownContainer>
        </div>
      </Accordion>
      <style jsx>{`
        .category-modal-container {
          display: flex;
          flex-direction: column;
        }

        @media (min-width: ${screen.mobileMax}) {
          .category-modal-container {
            display: none;
          }
        }

        @media (max-width: ${screen.mobileMax}) {
          .category-dropdown-container {
            display: none;
          }
        }
      `}</style>
    </>
  );
}
